export default {
      id: "warning-red-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#warning-red",
      toString: function () {
        return this.url;
      }
    }